import i18n, { use } from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'
import { englishTranslations } from '../../public/locale/locale_en'
import { frenchTranslations } from '../../public/locale/locale_fr'
import constants from './languages'


use(initReactI18next).use(LanguageDetector).init({
    debug: false,
    defaultNS: 'translations',
    fallbackLng: constants.DEFAULT,
    interpolation: {
        escapeValue: true,
        formatSeparator: ','
    },
    nonExplicitSupportedLngs: true,
    ns: [ 'translations' ],
    react: {
        bindI18n: 'languageChanged',
        bindI18nStore: '',
        transEmptyNodeValue: '',
        transKeepBasicHtmlNodesFor: [ 'br', 'strong', 'i' ],
        transSupportBasicHtmlNodes: true,
        useSuspense: true,
    },
    resources: {
        en: englishTranslations,
        fr: frenchTranslations
    },
    supportedLngs: [ constants.ENGLISH, constants.FRENCH ],
})


export default i18n
